module.exports = {"211081001":"烟台街道","211081002":"万宝桥街道","211081003":"古城街道","211081101":"佟二堡镇","211081102":"铧子镇","211081103":"张台子镇","211081104":"西大窑镇","211081105":"沈旦堡镇","211081106":"西马峰镇","211081107":"柳条寨镇","211081108":"柳河子镇","211081111":"大河南镇","211081114":"五星镇","211081205":"鸡冠山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211081.json
// module id = 665
// module chunks = 0